import { addDays } from './date.js';
/** How a day is ordered and how "today" is divided up.
 *
 *  These two rules used to live only on the server, which was fine while the
 *  server was the only thing that ever built a list. It is not any more: a device
 *  with no connection resolves its own pending writes onto the cached view and
 *  has to arrive at exactly the order the server would have sent, or a task will
 *  visibly jump the moment the connection comes back. */
/** Timed tasks first in clock order, then untimed, then by title.
 *  Completed items keep their slot rather than sinking — the design shows them in
 *  place so the day still reads as a day. */
export function sortInstances(a, b) {
    if (a.date !== b.date)
        return a.date < b.date ? -1 : 1;
    const at = a.task.startTime, bt = b.task.startTime;
    if (at && bt && at !== bt)
        return at < bt ? -1 : 1;
    if (at && !bt)
        return -1;
    if (!at && bt)
        return 1;
    return a.task.title.localeCompare(b.task.title);
}
/** Everything on the plate today: today's tasks, plus anything older still open.
 *  Deliberately *not* "overdue" — the past ones are ordinary tasks that happen to
 *  carry an older date. */
export function bucketToday(all, today) {
    return {
        stillOpen: all.filter((i) => !i.done && i.date < today).sort(sortInstances),
        today: all.filter((i) => i.date === today).sort(sortInstances),
    };
}
/** Does a task that runs from `start` to `end` touch any day in [from, to]? */
export const spanOverlaps = (start, end, from, to) => start <= to && (end ?? start) >= from;
/** A span worth putting on the front page: one running now, or one starting
 *  within the week. Anything further out belongs to the calendar, not to today —
 *  the point of the list is what is on rather than what is eventually coming. */
export const spanIsNear = (i, today, days = 7) => i.endDate !== null && !i.done && spanOverlaps(i.date, i.endDate, today, addDays(today, days));
//# sourceMappingURL=view.js.map